import { foundationTreeItemStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common/colors.hex';
export const zeroTreeItemStyles = (context, definition) => css `
  ${foundationTreeItemStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
    --base-height-multiplier: 15;

    font-size: --type-ramp-base-font-size;
    background-color: transparent;
  }

  :host([selected])::after {
    background:
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 10%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        top/100% 1px,
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 10%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        bottom/100% 1px;
    background-origin: border-box;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;
